
export class FileShareMassAffectationItemModel {
  providerInstanceResourceId: string|null;
  userId: string;
  share: string;
  path: string;
  name: string;
}
